import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LibPipeModule, LibDirectiveModule, SecurityModule } from '@mynexus/mynexus-ui-lib';
import { PrimeNgModule } from './prime-ng/prime-ng.module';
import { MfeCoreModule } from '@mynexus/mfe-core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule,
    LibPipeModule,
    LibDirectiveModule,
    SecurityModule,
    MfeCoreModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule,
    LibPipeModule,
    LibDirectiveModule,
    SecurityModule,
    MfeCoreModule
  ]
})
export class SharedModule { }
